import { atom } from "recoil";

export const buildVersionAtom = atom<string>({
  key: "buildVersionAtom",
  default: "",
});

export const buildTimestampAtom = atom<TDateISO>({
  key: "buildTimestampAtom",
  default: new Date().toISOString(),
});

export const buildNeedReloadAtom = atom<boolean>({
  key: "buildNeedReloadAtom",
  default: false,
});
